import { render } from "./ProsConsCard.vue?vue&type=template&id=578ea887"
import script from "./ProsConsCard.vue?vue&type=script&lang=js"
export * from "./ProsConsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__